import React from "react";
import { Link, useNavigate } from "react-router-dom";

import logoDark from "../../../assets/images/logo-dark.png";
import logoLight from "../../../assets/images/logo-light.png";
import loginImg from "../../../assets/images/login.jpg";

import Switcher from "../../../components/switcher";
import BackToHome from "../../../components/back-to-home";
import { createClient } from "../../../utils/supbase/client";
import { loginValidationSchema } from "../../../utils/resolvers";
import { useForm } from "react-hook-form";
import InputField from "../../../components/inputField";
import { useDispatch } from "react-redux";
import { setUser } from "../../../redux/feature/authSlice";

export default function Login() {
  const supabase = createClient();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const {
    handleSubmit,
    register,
    setValue,
    watch,
    setError,
    formState: { errors },
    reset,
  } = useForm({
    resolver: loginValidationSchema,
    defaultValues: {
      LoginEmail: "",
      password: "",
    },
  });

  const handleLogin = async (formValues) => {
    try {
      const { data, error } = await supabase.auth.signInWithPassword({
        email: formValues.LoginEmail,
        password: formValues.password,
      });

      if (data) {
        console.log("Login successful:", data);

        // Fetch additional user data (e.g., role) from your user table in Supabase
        const { data: userProfile, error: userError } = await supabase
          .from("users") // replace "users" with your actual table name
          .select("id, email, role") // make sure "role" is a column in your table
          .eq("id", data.user.id)
          .single();

        if (userError) {
          console.error("Error fetching user profile:", userError);
          return;
        }

        const userRole = userProfile.role;

        // Dispatch user details to Redux store
        dispatch(
          setUser({
            id: data.user.id,
            email: data.user.email,
            role: userRole,
          })
        );

        // Conditional navigation based on role
        if (userRole === "admin") {
          navigate("/admin/product-listing");
        } else {
          navigate("/");
        }
      } else if (error) {
        console.error("Login error:", error.message);
        setError("LoginEmail", {
          type: "manual",
          message: "Invalid login credentials",
        });
      }
    } catch (err) {
      console.error("An error occurred during login:", err);
    }
  };

  return (
    <>
      <section className="md:h-screen py-36 flex items-center bg-orange-500/10 dark:bg-orange-500/20 bg-[url('../../assets/images/hero/bg-shape.png')] bg-center bg-no-repeat bg-cover">
        <div className="container relative">
          <div className="grid grid-cols-1">
            <div className="relative overflow-hidden rounded-md shadow dark:shadow-gray-700 bg-white dark:bg-slate-900">
              <div className="grid md:grid-cols-2 grid-cols-1 items-center">
                <div className="relative md:shrink-0">
                  <img
                    className="lg:h-full h-full w-full object-cover md:h-[34rem]"
                    src={loginImg}
                    alt=""
                  />
                </div>

                <div className="p-8 lg:px-20">
                  <div className="text-center">
                    <Link to="/">
                      <img
                        src={logoDark}
                        className="mx-auto block dark:hidden"
                        alt=""
                      />
                      <img
                        src={logoLight}
                        className="mx-auto hidden dark:block"
                        alt=""
                      />
                    </Link>
                  </div>

                  <form
                    onSubmit={handleSubmit(handleLogin)}
                    className="text-start lg:py-20 py-8"
                  >
                    <div className="grid grid-cols-1">
                      <div className="mb-4">
                        <label className="font-semibold" htmlFor="LoginEmail">
                          Email Address:
                        </label>
                        <InputField
                          register={register}
                          onChange={(value) => {
                            setValue("LoginEmail", value);
                            setError("LoginEmail", null);
                          }}
                          errorMsg={errors?.LoginEmail?.message}
                          name="LoginEmail"
                          id="LoginEmail"
                          type="email"
                          className="mt-3 w-full py-2 px-3 h-10 bg-transparent dark:bg-slate-900 dark:text-slate-200 rounded outline-none border border-gray-100 dark:border-gray-800 focus:ring-0"
                          placeholder="name@example.com"
                        />
                      </div>

                      <div className="mb-4">
                        <label
                          className="font-semibold"
                          htmlFor="LoginPassword"
                        >
                          Password:
                        </label>
                        <InputField
                          register={register}
                          onChange={(value) => {
                            setValue("password", value);
                            setError("password", null);
                          }}
                          errorMsg={errors?.password?.message}
                          name="password"
                          id="LoginPassword"
                          type="password"
                          className="mt-3 w-full py-2 px-3 h-10 bg-transparent dark:bg-slate-900 dark:text-slate-200 rounded outline-none border border-gray-100 dark:border-gray-800 focus:ring-0"
                          placeholder="Password:"
                        />
                      </div>

                      <div className="flex justify-between mb-4">
                        <div className="flex items-center mb-0">
                          <input
                            className="form-checkbox rounded border-gray-100 dark:border-gray-800 text-orange-500 focus:border-orange-300 focus:ring focus:ring-offset-0 focus:ring-orange-200 focus:ring-opacity-50 me-2"
                            type="checkbox"
                            value=""
                            id="RememberMe"
                          />
                          <label
                            className="form-checkbox-label text-slate-400"
                            htmlFor="RememberMe"
                          >
                            Remember me
                          </label>
                        </div>
                        <p className="text-slate-400 mb-0">
                          <Link
                            to="/forgot-password"
                            className="text-slate-400"
                          >
                            Forgot password ?
                          </Link>
                        </p>
                      </div>

                      <div className="mb-4">
                        <input
                          type="submit"
                          className="py-2 cursor-pointer px-5 inline-block tracking-wide align-middle duration-500 text-base text-center bg-orange-500 text-white rounded-md w-full"
                          value="Login / Sign in"
                        />
                      </div>

                      <div className="text-center">
                        <span className="text-slate-400 me-2">
                          Don't have an account ?
                        </span>{" "}
                        <Link
                          to="/signup"
                          className="text-black dark:text-white font-bold inline-block"
                        >
                          Sign Up
                        </Link>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* <Switcher /> */}
      <BackToHome />
    </>
  );
}
